import { CustomIcons, Text, Link, Stack, styled } from '@/theme/index';

const StyledLink = styled(Link)({
  textDecoration: 'none',
  cursor: 'pointer',
  display: 'block',
  width: 'fit-content',
});

export const AccessibilityIconButton = () => {
  return (
    <StyledLink
      tabIndex={0}
      data-acsb="trigger"
      aria-label="Open accessibility interface"
    >
      <Stack spacing={1} direction="row" alignItems="center">
        <Text>Accessibility</Text>
        <CustomIcons.AccessibilityIcon
          fontSize="large"
          height="20"
          viewBox="0 0 40 20"
        />
      </Stack>
    </StyledLink>
  );
};
